export const phoneNumberCheckerFormTexts = {
  submitBtn: 'Показать',
};
